import { useContext, useEffect, useState } from "react";
import { AuthContext } from "@beeldit/user-and-access/auth/AuthContext";
import { t } from "i18next";
import { Button, Card, Tab, Tabs } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import useDetailsAction from "../actions/details/useDetailsAction";
import PlayersPage from "@main/players/pages/PlayersPage";
import { ListActionProvider as PlayerListActionProvider } from "./../../players/actions/list/ListActionContext";
import { CreateActionProvider as PlayerCreateActionProvider } from "./../../players/actions/create/CreateActionContext";
import { RemoveActionProvider as PlayerRemoveActionProvider } from "./../../players/actions/remove/RemoveActionContext";
import { EditActionProvider as PlayerEditActionProvider } from "./../../players/actions/edit/EditActionContext";
import GamesPage from "@main/games/pages/GamesPage";
import { ListActionProvider as GameListActionProvider } from "./../../games/actions/list/ListActionContext";
import { CreateActionProvider as GameCreateActionProvider } from "./../../games/actions/create/CreateActionContext";
import { RemoveActionProvider as GameRemoveActionProvider } from "./../../games/actions/remove/RemoveActionContext";
import { EditActionProvider as GameEditActionProvider } from "./../../games/actions/edit/EditActionContext";
import { StatisticsActionProvider as PlayerStatisticsActionProvider } from "./../../players/actions/statistics/StatisticsActionContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { icon } from "@fortawesome/fontawesome-svg-core/import.macro";
import { DetailsActionContext } from "../actions/details/DetailsActionContext";
import useGenerateGamesAction from "../actions/generate-games/useGenerateGamesAction";
import EnrollmentPlayersPage from "@main/players/pages/EnrollmentPlayersPage";
import { EnrollmentActionProvider } from "@main/players/actions/enrollment/EnrollmentActionContext";
import { UnenrollmentActionProvider } from "@main/players/actions/unenrollment/UnenrollmentActionContext";
import { PayActionProvider } from "@main/players/actions/pay/PayActionContext";
import { UnpayActionProvider } from "@main/players/actions/unpay/UnpayActionContext";

function CategoryDashboardPage() {
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();

  const { element } = useContext(DetailsActionContext);

  let { categoryId } = useParams();

  if (!categoryId) {
    categoryId = "0";
  }

  const {
    getFunction,
    onSubmitFunction,
    actionTemplate: detailsActionTemplate,
  } = useDetailsAction(parseInt(categoryId));

  const {
    initializeFunction: initializeGenerateGamesFunction,
    actionTemplate: generateGamesActionTemplate,
  } = useGenerateGamesAction();

  useEffect(() => {
    getFunction(categoryId);
  }, [categoryId]);

  /** Filtro con el que inicializamos las tablas asociadas al comercio en el que nos encontramos */
  const filters = { category_id: parseInt(categoryId) };
  const formDefaultValues = { category_id: parseInt(categoryId) };
  const formFilterValues = { category_id: parseInt(categoryId) };

  const rankingURL = process.env.REACT_APP_HOST_URL;

  const goToLeagues = () => {
    navigate(`/panel/leagues`);
  }

  const goToCategories = () => {
    navigate(`/panel/league/${element?.league_id}/categories`);
  }


  return (
    <>
      <div className="breadcrum mb-3">
        <a href="javascript:;" onClick={goToLeagues}>Ligas</a> {'>'} <a href="javascript:;" onClick={goToCategories}>Categorías</a> {'>'} <a href="javascript:;">{element?.name}</a>
      </div>
      <Tabs
        defaultActiveKey="games"
        id="uncontrolled-tab-example"
        className="mb-3"
      >
        <Tab eventKey="category" title={t("category")}>
          <Card>
            <Card.Header className="d-flex align-items-center justify-content-between ps-3 text-bg-primary">
              <span>{t("category")}</span>
              <div>
                {element && element.league_type == 0 ? (
                  <Button
                    className="icon-button btn-primary"
                    onClick={() => {
                      // abrir una nueva pestaña del navegador con un enlace
                      window.open(
                        `${rankingURL}categories/${categoryId}/ranking`,
                        "_blank"
                      );
                    }}
                  >
                    <FontAwesomeIcon
                      icon={icon({ name: "ranking-star", style: "solid" })}
                      className="me-2"
                    />
                  </Button>
                ) : (
                  <Button
                    className="icon-button btn-primary"
                    onClick={() => {
                      // abrir una nueva pestaña del navegador con un enlace
                      window.open(
                        `${rankingURL}categories/${categoryId}/show-bracket`,
                        "_blank"
                      );
                    }}
                  >
                    <FontAwesomeIcon
                      icon={icon({ name: "sitemap", style: "solid" })}
                      className="me-2"
                    />
                  </Button>
                )}
                <Button
                  className="icon-button btn-primary"
                  onClick={() => {
                    initializeGenerateGamesFunction(categoryId);
                  }}
                >
                  <FontAwesomeIcon
                    icon={icon({ name: "gears", style: "solid" })}
                    className="me-2"
                  />
                </Button>
              </div>
            </Card.Header>

            <Card.Body>
              {detailsActionTemplate}
              <div className="text-end">
                <Button variant="outline-primary" onClick={onSubmitFunction}>
                  {t("save_changes")}
                </Button>
              </div>
            </Card.Body>
            {generateGamesActionTemplate}
          </Card>
        </Tab>
        <Tab eventKey="games" title={t("games")}>
          <GameListActionProvider>
            <GameRemoveActionProvider>
              <GameCreateActionProvider>
                <GameEditActionProvider>
                  <GamesPage
                    filters={filters}
                    formDefaultValues={formDefaultValues}
                    formFilterValues={formFilterValues}
                  />
                </GameEditActionProvider>
              </GameCreateActionProvider>
            </GameRemoveActionProvider>
          </GameListActionProvider>
        </Tab>
        <Tab eventKey="players" title={t("players")}>
          <PayActionProvider>
            <UnpayActionProvider>
              <UnenrollmentActionProvider>
                <EnrollmentActionProvider>
                  <PlayerStatisticsActionProvider>
                    <PlayerListActionProvider>
                      <PlayerRemoveActionProvider>
                        <PlayerCreateActionProvider>
                          <PlayerEditActionProvider>
                            <EnrollmentPlayersPage
                              filters={filters}
                              formDefaultValues={formDefaultValues}
                            />
                          </PlayerEditActionProvider>
                        </PlayerCreateActionProvider>
                      </PlayerRemoveActionProvider>
                    </PlayerListActionProvider>
                  </PlayerStatisticsActionProvider>
                </EnrollmentActionProvider>
              </UnenrollmentActionProvider>
            </UnpayActionProvider>
          </PayActionProvider>
        </Tab>
      </Tabs>
    </>
  );
}

export default CategoryDashboardPage;
